exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3nXoxECiIs1Iv6RQet-hlu .label .clear{color:dycolor-internal(!clear-value-color,@theme-error)}\n", ""]);

// exports
exports.locals = {
	"root": "_3nXoxECiIs1Iv6RQet-hlu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/gotu-vue-common/src/components/form-input/FormInput.scss
// module id = 911
// module chunks = 1